import axios from "axios";

// import {Signer} from '@aws-amplify/core';
// "@aws-amplify/core": "^5.0.14",
// "aws4-sign": "^0.2.0",
// "aws4fetch": "^1.0.17",
import { getUserIdentity } from "./identity";
import { reverseReplaceString } from "./demo";

const convertToFormData = (payload) => {
    const formData = new FormData();
    for (const key in payload) {
        if (payload.hasOwnProperty(key)) {
            formData.append(key, payload[key]);
        }
    }
    return formData;
};

const Custom_Group_Profile_Pages = [
    '/amazon/marketing-stream',
    '/amazon-dayparting',
    '/amazon-automated-rules/',
    '/amazon-dayparting-tracking',
    '/amazon-ranking-configuration',
    '/amazon-ranking-activity',
    '/amazon-ranking-billing-payments'
]

const AddGroupFilters = [
    'snapshot',
    'master-overview',
    'targeting',
    'ranking',
    'search-query-performance'
]

const DistributorIdAllow = [
    'snapshot',
    'master-overview',
]

const authToken = JSON.parse(localStorage.getItem('User')) || {}

const getSignRequest = async (path, method, payload, isNode, signal) => {   
    // const aws = new AwsClient({ accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY + path, secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY, region: process.env.REACT_APP_AWS_REGION })
    // return aws.fetch(`https://api-v2.hectorai.live/login`, {method: method, body: JSON.stringify(payload) })
  const authToken = JSON.parse(localStorage.getItem('User')) || {}
  const isFlipKartPath = path && (path.indexOf('/flipkart-masteroverview') > -1 || path.indexOf('/flipkartsnapshots') > -1)
  const profileKey = isFlipKartPath ? 'flipkartProfile' : 'selectedProfileId';
  const getProfile = JSON.parse(sessionStorage.getItem(profileKey)) || {};

  const getGroupProfile = JSON.parse(sessionStorage.getItem('selectedGroupedProfileId')) || {};
  const masterFilter = JSON.parse(sessionStorage.getItem('master-account-filters')) || {}
  console.log("getSignRequest-masterFilter", masterFilter)
  const includeSBSpends = localStorage.getItem("include-sb-spends") == 'yes' ? true : localStorage.getItem("include-sb-spends") == 'no' ? false : true
  const distributorIdDetails = JSON.parse(sessionStorage.getItem('distributorId'))?.[getProfile?.profileId];
  // Handle both old format (single object) and new format (array)
  const vendorSourceValues = Array.isArray(distributorIdDetails) 
    ? distributorIdDetails.map(item => item.value)
    : distributorIdDetails?.value ? [distributorIdDetails.value] : [];

    console.log("Distributor-vendorSourceValues", vendorSourceValues)
    console.log("Distributor-distributorIdDetails", distributorIdDetails)

  const isCampaignGeneration = path.indexOf('/campaign-generation/') > -1;

  // Ensure payload is always an object (not null/undefined) before processing
  const safePayload = payload || {};
  
  if (isNode){
    // if(safePayload.profile_id) delete safePayload.profile_id
    if(safePayload && 'role' in safePayload && safePayload.role) delete safePayload.role
    if(path.indexOf('verify-reset-token') === -1) {
        if(safePayload && 'token' in safePayload && safePayload.token) delete safePayload.token
    }
    if(safePayload && 'account_type' in safePayload && safePayload.account_type) delete safePayload.account_type
  }



  const pathName = window.location.pathname
  const isAddGroupFilters = AddGroupFilters.some((item) => pathName.includes(item))
  const isDistributorAllow = DistributorIdAllow.some((item) => pathName.includes(item)) && getProfile?.vendor?.distributorView && Array.isArray(getProfile?.vendor?.distributorView) && getProfile?.vendor?.distributorView?.length > 0;
  const isDemoLogin = process.env.REACT_APP_DEMO_EMAIL && process.env.REACT_APP_DEMO_EMAIL.indexOf(authToken.email) > -1
  const isFormData = path.includes("upload-mapLevelsToASIN") || path.includes("upload-mapLevelsToFsn") || path.includes("upload-mapLevelsToProduct") || path.includes("upload-mapLevelsToSku") || path.includes("readFirstPartyUploadSheet") || path.includes("uploadFirstPartyData");
  const isMarketingStreamHourAPi = path.includes("getLastMarketingStreamHour") || path.includes("list-products-by-asin-search") || path.includes("list-brands-by-adgroup-search") || path.includes("amcAudienceListAgainstCampaign") || path.includes("amcAudienceDeleteAgainstCampaign") || path.includes("amcAudienceUpdateAgainstCampaign") || path.includes("listRuleNotification") || path.includes("updateRuleNotification") || path.includes("/ranking/list-ranking-crawls") || path.includes("/ranking/create-payment-user")
  const isAllowAdGroupFilters = path.includes('/keywords/bulk-update-keyword-details')
    let request = {         
        method: method,
        mode: 'cors',
        url: isNode === 1 ? process.env.REACT_APP_HTTP_URL + path  : process.env.REACT_APP_HTTP_URL + path,
        data: isFormData ? convertToFormData(safePayload) : JSON.stringify(
            {
                ...safePayload, 
                ...(!isNode && authToken ? {token: authToken.token} : {}),
                ...(!isNode && getProfile && authToken && {account_type: getProfile?.accountInfo?.type ? getProfile?.accountInfo?.type : 'Admin'}),
                ...(!isNode && getProfile && authToken && {role: getProfile?.accessLevel ? getProfile?.accessLevel : 'Admin'}),
                ...(!isNode && getProfile && authToken && {profileOwner: getProfile?.profileOwner ? getProfile?.profileOwner : authToken.email}),
                ...(!isNode && getProfile && getProfile?.datasetId != '' && {datasetId: getProfile?.datasetId ? getProfile?.datasetId : ''}),
                ...(!isNode && getProfile && getProfile?.timezone != '' && {timezone: getProfile?.timezone ? getProfile?.timezone : ''}),      
                ...(!isNode && path && path.indexOf('/amazon-snapshot') > -1 && getProfile && getProfile?.currencyCode != '' && {currencyCode: getProfile?.currencyCode ? getProfile?.currencyCode : ''}),
                ...(!isMarketingStreamHourAPi && (path && (path.indexOf('/amazon') > -1 || isAllowAdGroupFilters)) && isAddGroupFilters && masterFilter && Object.keys(masterFilter).length > 0 && masterFilter[getProfile.profileId] && masterFilter[getProfile.profileId]?.filter((filterItem) => filterItem?.keywords?.length > 0)?.length > 0 ? {
                    addgroup_filters: masterFilter[getProfile.profileId]?.filter((filterItem) => filterItem.level == 'ams' && filterItem?.keywords?.length > 0),
                } : {}),
                ...(!isMarketingStreamHourAPi && (path && (path.indexOf('/masteroverview') > -1 || path.indexOf('/snapshots') > -1 || path.indexOf('/flipkart-masteroverview') > -1 || path.indexOf('/flipkartsnapshots') > -1 || path.indexOf('/flipkart-retail-masteroverview') > -1 || path.indexOf('/flipkart-retail-snapshots') > -1)) && isAddGroupFilters && masterFilter && Object.keys(masterFilter).length > 0 && masterFilter[getProfile.profileId] && masterFilter[getProfile.profileId]?.filter((filterItem) => filterItem?.keywords?.length > 0)?.length > 0 ? {
                    addgroup_filters: masterFilter[getProfile.profileId]?.filter((filterItem) => filterItem.level != 'dsp' && filterItem?.keywords?.length > 0),
                } : {}),
                ...(!isMarketingStreamHourAPi && (path && (path.indexOf('/sqp') > -1)) && isAddGroupFilters && masterFilter && Object.keys(masterFilter).length > 0 && masterFilter[getProfile.profileId] && masterFilter[getProfile.profileId]?.filter((filterItem) => filterItem?.keywords?.length > 0)?.length > 0 ? {
                    addgroup_filters: masterFilter[getProfile.profileId]?.filter((filterItem) => filterItem.level != 'dsp' && filterItem.level != 'vendor' && filterItem?.keywords?.length > 0),
                } : {}),
                ...(!isMarketingStreamHourAPi && (path && (path.indexOf('/masteroverview') > -1 || path.indexOf('/snapshots') > -1)) && isAddGroupFilters ? {
                    is_include_sb: includeSBSpends,
                } : {}),
                ...(!isMarketingStreamHourAPi && (path && (path.indexOf('/masteroverview') > -1 || path.indexOf('/snapshots') > -1)) && isDistributorAllow && vendorSourceValues.length > 0 ? {
                    vendor_source: vendorSourceValues,
                } : {}),
                ...(!isMarketingStreamHourAPi && Custom_Group_Profile_Pages.some((item) => window.location.pathname.includes(item)) ? {
                    ...(safePayload?.profile_id && getGroupProfile && getGroupProfile?.profileId ? {profile_id: getGroupProfile.profileId } : {}),
                    ...(path && getGroupProfile && getGroupProfile?.profileId && (
                        path.indexOf('/day-parting/') > -1 || path.indexOf('/rule-automation/') > -1 || path.indexOf('/amazon-dayparting-tracking') > -1 || path.indexOf('/ranking/') > -1
                        ) && (
                            window.location.pathname.indexOf('/amazon-dayparting') > -1  || window.location.pathname.indexOf('/amazon-automated-rules') > -1 || window.location.pathname.indexOf('/amazon-dayparting-tracking') > -1 || window.location.pathname.includes('/amazon-ranking') > -1
                        ) ? {
                        add_account_filters: [
                            {
                                level: 'ams',
                                keywords: [getGroupProfile.profileId]
                            }
                        ]
                    } : {})
                } : {})
            }),
        ...(isNode === 1 ? {
            headers: {
                "content-type": isFormData ? "multipart/form-data" : "application/json",
                ...(authToken && authToken.token && !isCampaignGeneration ? {
                    "X-USER-IDENTITY": getUserIdentity(path, window.location.href.includes('amazon') && Custom_Group_Profile_Pages.some((item) => window.location.pathname.includes(item)) ? getGroupProfile : {}),
                    "Authorization": `Bearer ${authToken.token}`
                } : {})
            }, 
            baseURL: process.env.REACT_APP_HTTP_URL
        }: {}),
    }

    let newPayload = request;
    if(process.env.REACT_APP_DEMO_EMAIL && process.env.REACT_APP_DEMO_EMAIL.indexOf(authToken.email) > -1) {
        const jsonString = JSON.stringify(newPayload);
        const newString = await reverseReplaceString(jsonString)
        newPayload = JSON.parse(newString)   
    }

    const instance = axios.create();
    return instance({...newPayload, ...(signal != null ? { signal } : {})})


    //use amplify sign()function to create the signed headers;
    // let signedRequest =  Signer.sign(request,access_info,service_info)

    //remove host from header
    // delete signedRequest.headers['host']
    // delete signedRequest.headers['Content-Length']
    

    //I normally create an instance if I need to intercept my response or request
    // const instance = axios.create();
    // return instance(signedRequest)
}



const getService = ({ url, payload, nodeAPI = 1, signal = null }) => getSignRequest(url, 'GET', payload ?  payload : {}, nodeAPI, signal);
const postService = ({ url, payload, nodeAPI = 1, signal = null }) => getSignRequest(url, 'POST', payload, nodeAPI, signal);
const putService = ({ url, payload, nodeAPI = 1, signal = null }) => getSignRequest(url,'PUT', payload, nodeAPI, signal);
const patchService = ({ url, payload, nodeAPI = 1, signal = null }) => getSignRequest(url,'PATCH', payload, nodeAPI, signal);
const deleteService = ({ url, payload, nodeAPI = 1, signal = null }) => getSignRequest(url, 'DELETE', payload, nodeAPI, signal);

export const headersData = {
    "content-type": "application/json",
    ...(authToken && authToken.token ? {
        "X-USER-IDENTITY": getUserIdentity(''),
        "Authorization": `Bearer ${authToken.token}`
    } : {})
}

const services = {
    getService,
    postService,
    putService,
    deleteService,
    patchService
}

export default services;
